import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Icon from '../icon/Icon';
import P from '../containers/Paragraph';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { unitAllotmentTypes } from '../../types/products';
import { mapSilhouette } from '../../util/silhouettes';

const UnitAllotmentProductInfo = ({ unitAllotments, productName }) => (
  <>
    {unitAllotments &&
      unitAllotments.length > 0 &&
      unitAllotments.map(allotment => {
        const { unitAttributeName, unitAttributeValue } = allotment;
        const allotmentName = mapSilhouette({ unitAttributeName, unitAttributeValue });
        return (
          <div
            key={allotment.uniqueId}
            className='pdp__info_options flex-container row align-center pt2-sm pb2-sm prl3-sm mb8-sm'
          >
            <div className='gridwall__card_icon'>
              <Icon
                className='mr2-sm'
                name='box'
                alt={new TranslatedCopy({ id: 'global.unitAllotments' }).toString()}
              />
            </div>

            <P className='lh16-sm'>
              <TranslatedCopy
                id='pdp.unitAllotments.copy'
                values={{
                  remaining: allotment.allotmentAmount - allotment.totalSpend,
                  total: allotment.allotmentAmount,
                  name: allotmentName || productName
                }}
              />
            </P>
          </div>
        );
      })}
  </>
);

UnitAllotmentProductInfo.defaultProps = {
  unitAllotments: null
};

UnitAllotmentProductInfo.propTypes = {
  unitAllotments: PropTypes.arrayOf(unitAllotmentTypes),
  productName: PropTypes.string.isRequired
};

export default UnitAllotmentProductInfo;
